import { render } from "./RegisterSmall.vue?vue&type=template&id=6f352dcd&scoped=true&ts=true"
import script from "./RegisterSmall.vue?vue&type=script&lang=ts"
export * from "./RegisterSmall.vue?vue&type=script&lang=ts"

import "./RegisterSmall.vue?vue&type=style&index=0&id=6f352dcd&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f352dcd"]])

export default __exports__